var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _path4, _path5, _path6, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewToDo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5831C0 7.24508 2.70602 4.53906 6.04405 4.53906H59.4825C62.8205 4.53906 65.5265 7.24508 65.5265 10.5831V74.7326C65.5265 78.0707 62.8205 80.7767 59.4825 80.7767H6.04405C2.70602 80.7767 0 78.0707 0 74.7326V10.5831Z",
    fill: "#60C2A5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.375,
    y: 32.1113,
    width: 28.4574,
    height: 3.27386,
    rx: 1.00734,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.25,
    y: 15.7432,
    width: 49.8634,
    height: 7.05139,
    rx: 1.00734,
    fill: "#007580"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 60,
    width: 16.6211,
    height: 3.27386,
    rx: 1.00734,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.375,
    y: 43.1924,
    width: 28.4574,
    height: 3.27386,
    rx: 1.00734,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.375,
    y: 54.2734,
    width: 28.4574,
    height: 3.27386,
    rx: 1.00734,
    fill: "#007580"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 12.909,
    y: 30.4754,
    width: 6.54772,
    height: 6.54772,
    rx: 0.377753,
    stroke: "white",
    strokeWidth: 0.755507
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 12.909,
    y: 42.3113,
    width: 6.54772,
    height: 6.54772,
    rx: 0.377753,
    stroke: "white",
    strokeWidth: 0.755507
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 12.909,
    y: 52.6375,
    width: 6.54772,
    height: 6.54772,
    rx: 0.377753,
    stroke: "white",
    strokeWidth: 0.755507
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0518 33.208C15.8161 32.9292 15.399 32.8942 15.1201 33.13C14.8413 33.3657 14.8064 33.7829 15.0421 34.0617L16.8562 36.2074C17.0919 36.4863 17.5091 36.5212 17.7879 36.2855C18.0668 36.0497 18.1017 35.6326 17.866 35.3537L16.0518 33.208Z",
    fill: "#3A7463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3438 30.8633L21.382 30.9015C21.8772 31.3968 21.8772 32.1998 21.382 32.695L17.8242 36.2528C17.566 36.511 17.1474 36.511 16.8892 36.2528C16.631 35.9946 16.631 35.576 16.8892 35.3178L21.3438 30.8633Z",
    fill: "#3A7463"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0518 44.2881C15.8161 44.0092 15.399 43.9743 15.1201 44.2101C14.8413 44.4458 14.8064 44.8629 15.0421 45.1418L16.8562 47.2875C17.0919 47.5663 17.5091 47.6013 17.7879 47.3655C18.0668 47.1298 18.1017 46.7126 17.866 46.4338L16.0518 44.2881Z",
    fill: "#3A7463"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3438 41.9453L21.382 41.9835C21.8772 42.4788 21.8772 43.2818 21.382 43.7771L17.8242 47.3348C17.566 47.593 17.1474 47.593 16.8892 47.3348C16.631 47.0766 16.631 46.658 16.8892 46.3998L21.3438 41.9453Z",
    fill: "#3A7463"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3227 50.4737C55.7924 50.6159 55.3071 50.1305 55.4492 49.6002L60.5721 30.4812C60.7142 29.9509 61.3771 29.7732 61.7654 30.1615L75.7614 44.1575C76.1497 44.5458 75.972 45.2087 75.4417 45.3508L56.3227 50.4737Z",
    fill: "#FF7F50"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0156,
    y: 41.7041,
    width: 5.36771,
    height: 11.0179,
    rx: 0.713254,
    transform: "rotate(-135 68.0156 41.7041)",
    fill: "#FF7F50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewToDo);
export default __webpack_public_path__ + "static/media/new-to-do.aa289706e42333bfd1befc1e9187740a.svg";
export { ForwardRef as ReactComponent };